import { ProgressiveDataReq } from '@callrail/inti/src/inti/proto/progressive_data';
import { camelCase } from 'lodash-es';
import protobufjs from 'protobufjs';

export class ProgressiveDataXformer {
  private readonly operation: string;
  private readonly integrationId: number;
  private readonly payload: any;

  /**
   * Constructor
   *
   * @constructor
   * @param {string} operation
   * @param {number} integrationId
   * @param {any} payload - JSON needed to create the integration-type request object
   *
   */
  constructor(operation: string, integrationId: number, payload: any = {}) {
    this.operation = operation;
    this.integrationId = integrationId;
    this.payload = payload;
  }

  /**
   * Returns ProgressiveDataReq object with a valid integration-type request
   * field
   *
   * @return {ProgressiveDataReq}
   *
   */
  public toReqProtoObj(): ProgressiveDataReq {
    let baseObj = {
      integrationId: this.integrationId,
    };
    baseObj[`${this.buildReqFieldName()}`] = this.buildIntegrationReqProtoObj();

    return baseObj;
  }

  /**
   * Returns Base64 string representation of binary ProgressiveDataReq message
   *
   * @return {string}
   *
   */
  public toReqProtoBase64(): string {
    const protoObj = this.toReqProtoObj();

    const uint8 = ProgressiveDataReq.encode(protoObj).finish();
    return protobufjs.util.base64.encode(uint8, 0, uint8.length);
  }

  private buildReqFieldName(): string {
    return `${camelCase(this.operation)}Req`;
  }

  private buildIntegrationReqProtoObj(): any {
    return this.payload;
  }
}
